import React from 'react';

import ApiConnectionsContainer from '@totem/components/administration/apiConnections/ApiConnectionsContainer';
import ApiConnectionsLayout, {
  ApiConnectionsExtra,
} from '@totem/components/administration/apiConnections/ApiConnectionsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const ApiConnectionsPage = () => (
  <ContentLayout>
    <ApiConnectionsContainer>
      <IBCard isCovered title="API Connections" extra={<ApiConnectionsExtra />}>
        <ApiConnectionsLayout />
      </IBCard>
    </ApiConnectionsContainer>
  </ContentLayout>
);

export default ApiConnectionsPage;
